import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/", key: "home", label: "Home" },
  { to: "/about", key: "about", label: "About" },
  { to: "/offerings", key: "offerings", label: "What we offer" },
  { to: "/join", key: "join", label: "Join the village" },
];

const navClass = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-300 hover:text-primary ${isActive ? "text-primary" : "text-foreground/75"}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-background/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 lg:px-10">
        <Link to="/" data-testid="header-logo-link"><Logo /></Link>
        <nav className="hidden items-center gap-10 lg:flex">
          {LINKS.map((l) => (
            <NavLink key={l.key} to={l.to} end className={navClass} data-testid={`nav-${l.key}-link`}>{l.label}</NavLink>
          ))}
          <Link to="/contact" data-testid="nav-enquire-button"
            className="rounded-sm bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground transition-transform duration-300 hover:-translate-y-0.5">
            Contact
          </Link>
        </nav>
        <button className="lg:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="mobile-menu-toggle">
          {open ? <X className="h-6 w-6 text-primary" /> : <Menu className="h-6 w-6 text-primary" />}
        </button>
      </div>
      {open && (
        <nav className="flex flex-col gap-4 border-t border-border/60 px-6 py-6 lg:hidden" data-testid="mobile-menu">
          {[...LINKS, { to: "/contact", key: "contact", label: "Contact" }].map((l) => (
            <Link key={l.key} to={l.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.key}-link`}
              className="font-display text-2xl font-bold text-foreground">{l.label}</Link>
          ))}
        </nav>
      )}
    </header>
  );
};
